import { Component, Vue} from 'nuxt-property-decorator';
import { mapState } from 'vuex';
import { IMainLocation } from '~/types/region';

@Component({
    components: {
        popup: require('~/components/ui/dialog').default,
        citySelector: require("./city-selector").default,
    },
    computed: mapState(['region', 'user'])
})
export default class BlackHeaderComponent extends Vue {

    public showCitySelector = false;
    public region!: IMainLocation;
    public user!: User;

    showLoginForm() {
        this.$store.commit('setLoginFormState', true);
    }

    get phoneNumber() {
        if (!this.region?.contact.phones?.length) {
            return null;
        }

        return this.region.contact.phones[0].trim();
    }

    preloadCitySelector() {
        console.log('preload')
        this.$store.dispatch('data/GetCityList');
    }
}
